import { lazy } from "react";
import { IRouteDefinition, ISubModuleRoutes } from "../routing";

import FrontPage from "./havainnot/views/FrontPage";
import WorklistPage from "./havainnot/views/WorklistPage";
import NewObservationPage from "./havainnot/views/NewObservationPage";
import ObservationPage from "./havainnot/views/ObservationPage";
import OpenObservationPage from "./havainnot/views/OpenObservationPage";
import ObservationPrintPage from "./havainnot/views/ObservationPrintPage";
import AnonymousObservationPage from "./havainnot/views/AnonymousNewObservationPage";
import EditObservationPage from "./havainnot/views/EditObservationPage";
const MapPage = lazy(() => import(/* webpackChunkName: 'MapPage' */ "./havainnot/views/MapPage"));

export enum HavainnotRouteId {
    HavainnotFrontPage = "havainnot-front",
    NewObservationPage = "havainnot-new-observation",
    EditObservationPage = "havainnot-edit-observation",
    ObservationPage = "havainnot-observation-detail",
    OpenObservationPage = "havainnot-open-observation-detail",

    AnonymousNewObservation = "anonymous-new-observation",
    AnonymousObservation = "anonymous-observation",

    WorklistPage = "havainnot-work-queue",

    MissingRole = "missing-correct-role",

    ObservationPrint = "observation-print",
    MapPage = "havainnot-map-page",

    SchemaTest = "schema-test",
}

export const havainnotRoutes: IRouteDefinition[] = [
    {
        id: HavainnotRouteId.HavainnotFrontPage,
        exact: true,
        path: "/",
        render: () => <FrontPage />,
    },
    {
        id: HavainnotRouteId.WorklistPage,
        exact: true,
        path: "/tyojono",
        render: () => <WorklistPage />,
    },
    {
        id: HavainnotRouteId.MapPage,
        exact: true,
        path: "/kartta",
        render: () => <MapPage />,
    },
    {
        id: HavainnotRouteId.NewObservationPage,
        exact: true,
        path: "/uusi-havainto/:formType",
        render: () => <NewObservationPage />,
    },
    {
        id: HavainnotRouteId.OpenObservationPage,
        exact: true,
        path: "/avaa-havainto/:packageId",
        render: () => <OpenObservationPage />,
    },
    {
        id: HavainnotRouteId.ObservationPage,
        exact: true,
        path: "/havainto/:observation",
        render: () => <ObservationPage />,
    },
    {
        id: HavainnotRouteId.EditObservationPage,
        exact: true,
        path: "/havainto/muokkaus/:observation",
        render: () => <EditObservationPage />,
    },

    {
        id: HavainnotRouteId.ObservationPrint,
        requireAuth: false,
        exact: false,
        path: "/tulosta/havainto",
        render: () => <ObservationPrintPage />,
    },
    {
        id: HavainnotRouteId.AnonymousNewObservation,
        requireAuth: false,
        exact: false,
        path: "/anonyymilomake/:packageId",
        render: () => <AnonymousObservationPage />,
    },
    {
        id: HavainnotRouteId.AnonymousObservation,
        requireAuth: false,
        exact: true,
        path: "/anonyymi/havainto/:package",
        component: () => <ObservationPrintPage />,
    },

    {
        id: HavainnotRouteId.MissingRole,
        exact: true,
        requireAuth: false,
        path: "/ei_oikeutta",
        render: () => <div> Ei oikeutta </div>,
    },
];

const HavainnotRouting: ISubModuleRoutes = {
    prefix: "havainnot",
    routes: havainnotRoutes,
    template: lazy(() => import(/* webpackChunkName: 'HavainnotApp' */ "./HavainnotApp")),
    routeId: HavainnotRouteId,
};

export default HavainnotRouting;
